import { Container } from "@mike/crt";

/**
 * Classic TV test color bars pattern
 * SMPTE color bars: White, Yellow, Cyan, Green, Magenta, Red, Blue, Black
 */
const COLOR_BARS = [
  "#FFFFFF", // White
  "#FFFF00", // Yellow
  "#00FFFF", // Cyan
  "#00FF00", // Green
  "#FF00FF", // Magenta
  "#FF0000", // Red
  "#0000FF", // Blue
  "#000000", // Black
];

export function TestColorScreen() {
  return (
    <Container
      width="100%"
      height="100%"
      flexDirection="row"
      backgroundColor="#000000"
    >
      {COLOR_BARS.map((color, index) => (
        <Container
          key={index}
          flexGrow={1}
          height="100%"
          backgroundColor={color}
        />
      ))}
    </Container>
  );
}
